/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getRentitemsReport } from '../graphql';

export default (itemIds: any) => {
  const [freshSumData, sumData]: any = useLazyQuery(getRentitemsReport, {
    variables: { itemIds },
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (itemIds?.length > 0 && sumData?.called === false) {
      console.log('Calling freshSumData with itemIds:', itemIds);
      freshSumData();
    }
  }, [itemIds, sumData?.called]);

  const rdata = sumData?.data?.['getRentitemsReport']?.data;
  const data = rdata ? JSON.parse(rdata) : null;

  const refreshchart = () => sumData?.refetch();

  return {
    data,
    refreshchart,
    sumData,
  };
};
